import Youtube from '@tiptap/extension-youtube';

function getVideoIdFromUrl(url) {
  const regex = /(?:https?:\/\/)?(?:www\.)?youtube\.com\/watch\?v=([a-zA-Z0-9_-]+)/;
  const match = url.match(regex);
  return match ? match[1] : null;
}

const YoutubeExtension = Youtube.configure({
  disableKBcontrols: true,
  modestBranding: false,
  controls: false,
}).extend({
  addAttributes() {
    return {
      ...this.parent?.(),
      'data-resource-id': {
        default: null,
        parseHTML: (element) => element.getAttribute('data-resource-id'),
      },
      videoUrl: {
        default: '',
        parseHTML: (element) => element.getAttribute('data-video-url'),
      },
    };
  },
  renderHTML({ node }) {
    const { src, 'data-resource-id': resourceId } = node.attrs;
    const videoId = getVideoIdFromUrl(src);

    return [
      'div',
      {
        'data-youtube-video': '',
        contenteditable: 'true',
        'data-resource-id': resourceId,
        'data-video-url': src,
        class: 'story-youtube-video-container',
      },
      [
        'iframe',
        {
          width: '640',
          height: '480',
          allowfullscreen: 'true',
          autoplay: 'false',
          disablekbcontrols: 'false',
          enableiframeapi: 'false',
          endtime: '0',
          ivloadpolicy: '0',
          loop: 'false',
          modestbranding: 'false',
          src: `https://www.youtube.com/embed/${videoId}`,
        },
      ],
    ];
  },
});

export default YoutubeExtension;
